import type { ReviewingAgent } from '../../pm-plugins/thinking-plugin';
// Type-only, so this module stays free of the resolver's runtime dependencies.
import type { ContentReviewerAgent } from '../hooks/useContentReviewerAgentResolver';

/**
 * Narrows a resolved agent to the identity published in plugin state. Returns `null` when the
 * agent can't identify itself (no id, or a blank name), so consumers fall back to generic Rovo
 * copy rather than rendering an empty name.
 */
export function toReviewingAgent(agent: ContentReviewerAgent | undefined): ReviewingAgent | null {
	const name = agent?.name?.trim();
	if (!agent?.id || !name) {
		return null;
	}

	return {
		id: agent.id,
		name,
		namedId: agent.external_config_reference ?? agent.named_id,
		identityAccountId: agent.identity_account_id,
	};
}
